import { addItemsToCartWithDrawer, wasLoadingShellAborted } from '@theme/pb-builder-launch';
import { bootBuilderOpen } from '@theme/pb-builder-boot';

let openInFlight = null;

function setButtonLoading(btn, loading) {
  if (!btn) return;
  btn.classList.toggle('product-card-action-trigger--loading', loading);
  btn.toggleAttribute('aria-busy', loading);
  if (loading) {
    btn.dataset.pbWasDisabled = btn.disabled ? '1' : '0';
    btn.disabled = true;
  } else {
    btn.disabled =
      btn.dataset.pbWasDisabled === '1' || btn.classList.contains('product-card-action-trigger--disabled');
    delete btn.dataset.pbWasDisabled;
  }
}

async function openBuilderFromCard(btn) {
  const handle = btn.dataset.productHandle;
  const productId = btn.dataset.productId;
  if (!handle || !productId) return;

  setButtonLoading(btn, true);
  try {
    await bootBuilderOpen({
      entry: 'card',
      handle,
      productId,
      loadingShell: false,
      suspendCartDrawer: true,
    });
    if (wasLoadingShellAborted()) return;
  } catch (err) {
    if (!wasLoadingShellAborted()) {
      alert(err?.message || 'Could not open customizer. Please try again.');
    }
  } finally {
    setButtonLoading(btn, false);
  }
}

async function plainAddFromCard(btn) {
  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  setButtonLoading(btn, true);
  try {
    await addItemsToCartWithDrawer([{ id: Number(variantId), quantity: 1 }], null, '', {
      closeBuilder: false,
    });
  } catch (err) {
    /* alert handled in addItemsToCartWithDrawer */
  } finally {
    setButtonLoading(btn, false);
  }
}

async function plainChooseFromCard(btn, event) {
  const card = btn.closest('product-card');
  const quickAdd = card?.querySelector('quick-add-component');
  if (!quickAdd || typeof quickAdd.handleClick !== 'function') {
    const link = card?.querySelector('.product-card__link');
    if (link?.href) window.location.href = link.href;
    return;
  }
  setButtonLoading(btn, true);
  try {
    await quickAdd.handleClick(event);
  } finally {
    setButtonLoading(btn, false);
  }
}

async function handleCardAction(btn, event) {
  if (btn.disabled || btn.classList.contains('product-card-action-trigger--disabled')) return;

  if (btn.dataset.hasBuilder === 'true') {
    await openBuilderFromCard(btn);
    return;
  }

  if (btn.dataset.quickAddMode === 'add') {
    await plainAddFromCard(btn);
    return;
  }

  await plainChooseFromCard(btn, event);
}

document.addEventListener(
  'click',
  (event) => {
    const btn = event.target.closest('[data-pb-card-open]');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();
    if (openInFlight) return;
    openInFlight = handleCardAction(btn, event).finally(() => {
      openInFlight = null;
    });
  },
  true
);
